/* global axios */
import ApiClient from './ApiClient';

class WhatsappConnectionsAPI extends ApiClient {
  constructor() {
    super('whatsapp_connections', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  syncAll() {
    return axios.post(`${this.url}/sync_all`);
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync/${inboxId}`);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new WhatsappConnectionsAPI();
